import React from 'react';

export default function CouponSection({styles}) {
  return (
    <section className={`${styles.container} ${styles.smartCouponSection}`}>

          <div className={`${styles.container} ${styles.couponSection}`}>
            <div className={styles.headingContainer}>
              <h1 className={styles.sectionTitle}>
                Smart Coupons That Boost Sales, Not Discounts
              </h1>
            </div>
          </div>
          <div className={`${styles.columnCard} ${styles.smartCoupon}`}>
            <div className={`${styles.columnText} half-width`}>
              <p className={styles.columnTextPara}>
                Avoid losing profits through blanket discounts. Instant AI
                provides the minimum incentive required to finalize each sale,
                focusing on high-value customers with exclusive deals while
                safeguarding your margins.
              </p>
              <p className={styles.columnTextPara}>
                A/B test every offer to find the ideal balance between
                conversion and profitability.
              </p>
            </div>
            <div className={`${styles.smartCouponColumnImage} half-width`}>
              <img
                className={styles.smartCouponImage}
                src="/images/smartCoupon.webp"
                alt="Coupon example."
              />
            </div>
          </div>
        </section>  
  );
}